import type { IUseCase } from '@/shared/contracts/use-case.contract';

import type {
  SearchMerchantsRequest,
  SearchMerchantsResponse,
} from '@/modules/stores/types/search-merchants';
import { SEARCH_ENDPOINT } from '../types/search-merchants';
import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';

export type UseCaseInput = SearchMerchantsRequest;
export type UseCaseOutput = SearchMerchantsResponse;

export class SearchMerchantsUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { latitude, longitude, delivery_type, page, per_page, search } = input;

    if (!latitude || !longitude) {
      throw new Error('Latitude and longitude are required');
    }

    const queryParams = new URLSearchParams({
      latitude: latitude.toString(),
      longitude: longitude.toString(),
      delivery_type: delivery_type.toString(),
      ...(page && { page: page.toString() }),
      ...(per_page && { per_page: per_page.toString() }),
      ...(search && { search }),
    });

    const response = await this.client.sendRequest<UseCaseOutput, undefined>({
      method: HttpMethod.GET,
      endpoint: `${SEARCH_ENDPOINT}?${queryParams.toString()}`,
    });

    return response;
  }
}
